/*
 * @Description: '产品中心'页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: 'product',
        component: resolve => require(['@/views/product'], resolve),
        name: 'Product',
        meta: {
            nav: '产品中心'
        }
    },
    {
        path: 'product/:id',
        component: resolve => require(['@/views/product/detail'], resolve),
        name: 'Product_Detail',
        meta: {
            nav: '产品中心'
        }
    },
      
]



// WEBPACK FOOTER //
// ./src/router/product.js